import logo from './logo.svg';
import './App.css';
import React from 'react';
import Header from './Components/Header.jsx';
import AboutUs from './Components/AboutUs.jsx';
import Banner from './Components/Banner.jsx';
import ContactInfo from './Components/ContactInfo.jsx';
import Footer from './Components/Footer.jsx';
import Map from './Components/Map.jsx';
import Menu from './Components/Menu.jsx';
import Services from './Components/Services.jsx';
import Office from './Components/office.jsx';
function App() {
  return (
    <div className="App">
      <Header/>
      <Menu></Menu>
      <Banner text="Experts in Senior Services!"></Banner>
      <Office></Office>
      <AboutUs></AboutUs>
      <Services></Services>
      <Map></Map>
      <ContactInfo></ContactInfo>
      <Footer/>
    </div>
  );
}

export default App;
